import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.insertFiscalCodeUserRegistration.pageTitle',
    defaultMessage: 'Inserisci codice fiscale',
    description: 'Title of the insert fiscal code user registration page',
  },
  pageSubtitle: {
    id: 'features.insertFiscalCodeUserRegistration.pageSubtitle',
    defaultMessage:
      'Inserisci il codice fiscale del Legale Rappresentante o Procuratore',
    description: 'Subtitle of the insert fiscal code user registration page',
  },
  buttonInsertFiscalCode: {
    id: 'features.insertFiscalCodeUserRegistration.buttonInsertFiscalCode',
    defaultMessage: 'Ok',
    description: 'Label of the insert fiscal code user registration button',
  },
  disclaimerInsertFiscalCode: {
    id: 'features.insertFiscalCodeUserRegistration.disclaimerInsertFiscalCode',
    defaultMessage:
      'Per procedere con la registrazione del cliente Codice {userCode} - Cod. Fisc. / P.IVA {vatCodeFiscalCode} inserire il proprio Codice Fiscale.',
    description: 'Text of disclaimer insert fiscal code user registration page',
  },
  disclaimerInsertFiscalCodeFiduciaria: {
    id: 'features.insertFiscalCodeUserRegistration.diclaimerInsertFiscalCodeFiduciaria',
    defaultMessage:
      'Per procedere con la registrazione del cliente Codice {userCode} - P.IVA {vatCodeFiscalCode} inserire il proprio Codice Fiscale.',
    description: 'Text of disclaimer insert fiscal code user registration page',
  },
  labelInsertFiscalCodeInputText: {
    id: 'features.insertFiscalCodeUserRegistration.labelInsertFiscalCodeInputText',
    defaultMessage: 'Codice fiscale',
    description: 'Label of the insert fiscal code user registratio input text',
  },
  placeholderInsertFiscalCodeInputText: {
    id: 'features.insertFiscalCodeUserRegistration.placeholderInsertFiscalCodeInputText',
    defaultMessage: 'Inserisci codice fiscale',
    description:
      'Placeholder of the insert fiscal code user registratio input text',
  },
  errorPersonalDataConstraints: {
    id: 'features.insertFiscalCodeUserRegistration.errorPersonalDataConstraints',
    defaultMessage:
      'Al momento non è possibile attivare i servizi digitali. Si invita a contattare il proprio consulente finanziario di riferimento per ulteriori specifiche',
    description: 'Error message personal data constraints',
  },
  errorUserAlreadyRegistered: {
    id: 'features.insertFiscalCodeUserRegistration.errorUserAlreadyRegistered',
    defaultMessage:
      'Non è possibile proseguire con la registrazione. Contattare il Servizio Clienti al numero 02.8898.7005, attivo dal Lunedì al Venerdì dalle ore 9:00 alle 18:00. (Costo di una chiamata nazionale tariffata a seconda del profilo del proprio operatore telefonico)',
    description: 'Error message user already registered',
  },
  errorCfNoFiduciarie: {
    id: 'features.insertFiscalCodeUserRegistration.errorCfNoFiduciarie',
    defaultMessage:
      'Non è possibile proseguire con la registrazione, il documento identificativo depositato risulta scaduto. Contattare il Servizio Clienti  al numero 02.8898.7005, attivo dal Lunedì al Venerdì dalle ore 9:00 alle 18:00. (Costo di una chiamata nazionale tariffata a seconda del profilo del proprio operatore telefonico)',
    description: 'Error message cf no fiduciarie',
  },
  errorCfNonAssociato: {
    id: 'features.insertFiscalCodeUserRegistration.errorCfNonAssociato',
    defaultMessage:
      'Al momento non è possibile attivare i servizi digitali. Si invita a contattare telefonicamente il servizio di assistenza dedicato, al numero 02.8898.7005, attivo dal Lunedì al Venerdì dalle ore 9:00 alle 18:00. (Costo di una chiamata nazionale tariffata a seconda del profilo del proprio operatore telefonico)',
    description: 'Error message cf no fiduciarie',
  },
  errorCfNonAssociatoFiduciaria: {
    id: 'features.insertFiscalCodeUserRegistration.errorCfNonAssociatoFiduciaria',
    defaultMessage:
      'Il Codice Fiscale inserito non risulta associato ad una società Fiduciaria.',
    description: 'Error message cf no fiduciaria',
  },
  errorPivaNonAssociata: {
    id: 'features.insertFiscalCodeUserRegistration.errorPivaNonAssociata',
    defaultMessage: 'La Partita IVA non risulta associata a nessun cliente.',
    description: 'Error message piva no fiduciaria',
  },
  errorUtenteInesistente: {
    id: 'features.insertFiscalCodeUserRegistration.errorUtenteInesistente',
    defaultMessage: 'Il Codice Utente non risulta associato a nessun cliente.',
    description: 'Error message cf no fiduciarie',
  },
  errorDocumentNotAdmitted: {
    id: 'features.insertFiscalCodeUserRegistration.errorDocumentNotAdmitted',
    defaultMessage:
      'Non è possibile proseguire con la registrazione, il documento identificativo depositato non è tra quelli ammessi. Contattare il Servizio Clienti al numero 02.8898.7005, attivo dal Lunedì al Venerdì dalle ore 9:00 alle 18:00. (Costo di una chiamata nazionale tariffata a seconda del profilo del proprio operatore telefonico)',
    description: 'Error message document not admitted',
  },
  errorUtenteNonValido: {
    id: 'features.userRegistration.errorUtenteNonValido',
    defaultMessage:
      'Non è possibile proseguire con la registrazione. Contattare il Servizio Clienti al numero 02.8898.7005, attivo dal Lunedì al Venerdì dalle ore 9:00 alle 18:00. (Costo di una chiamata nazionale tariffata a seconda del profilo del proprio operatore telefonico)',
    description: 'Error message user not valid',
  },
  errorExpiredDocument: {
    id: 'features.insertFiscalCodeUserRegistration.errorExpiredDocument',
    defaultMessage:
      'Non è possibile proseguire con la registrazione, il documento identificativo depositato risulta scaduto. Contattare il Servizio Clienti al numero 02.8898.7005, attivo dal Lunedì al Venerdì dalle ore 9:00 alle 18:00. (Costo di una chiamata nazionale tariffata a seconda del profilo del proprio operatore telefonico)',
    description: 'Error message expired document',
  },
  errorImpossibleActivation: {
    id: 'features.insertFiscalCodeUserRegistration.errorImpossibleActivation',
    defaultMessage:
      'Non è possibile proseguire con la registrazione, il documento identificativo depositato risulta scaduto. Contattare il Servizio Clienti  al numero 02.8898.7005, attivo dal Lunedì al Venerdì dalle ore 9:00 alle 18:00. (Costo di una chiamata nazionale tariffata a seconda del profilo del proprio operatore telefonico)',
    description: 'Error message impossible activation',
  },
  errorInvalidFiscalCodeFormat: {
    id: 'features.insertFiscalCodeUserRegistration.errorInvalidFiscalCodeFormat',
    defaultMessage:
      'Il Codice fiscale risulta non essere stato inserito correttamente. Si prega di controllare.',
    description: 'Error invalid fiscal code format',
  },
});
